export const CONTACT = {
  phoneDisplay: "+91 7008164161",
  phoneLink: "tel:+917008164161",
  whatsappNumber: "917008164161",
  email: "mydotnetservices@gmail.com",
  emailLink: "mailto:mydotnetservices@gmail.com",
  addressLines: [
    "Dotnet Services",
    "Near Bank of Baroda Main Branch",
    "Radharani Pada",
    "Balangir, Odisha \u2013 767001",
    "India",
  ],
};

export const WHATSAPP_DEFAULT_MESSAGE = `Hello Dotnet Services,

I am interested in developing a digital project.

Service required:
Mobile App / Web Application / Website

Please contact me to discuss the project.`;

export function buildWhatsappLink(message) {
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(message)}`;
}

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Projects", id: "projects" },
  { label: "Process", id: "process" },
  { label: "Why Us", id: "why-us" },
  { label: "Contact", id: "contact" },
];

export const SERVICES = [
  {
    id: "mobile-app",
    icon: "Smartphone",
    title: "Mobile Application Development",
    description:
      "Custom mobile applications for businesses, startups, marketplaces, service providers, booking platforms, delivery businesses, and digital-first business ideas.",
    examples: [
      "Customer applications",
      "Booking applications",
      "Marketplace applications",
      "Delivery applications",
      "Business-management applications",
      "Admin-connected mobile applications",
    ],
  },
  {
    id: "web-app",
    icon: "Code2",
    title: "Web Application Development",
    description:
      "Custom browser-based applications designed to manage business operations and provide powerful online functionality.",
    examples: [
      "Admin dashboards",
      "Management systems",
      "Customer portals",
      "Booking systems",
      "Order management",
      "Business automation",
      "Internal business tools",
    ],
  },
  {
    id: "website-dev",
    icon: "Globe",
    title: "Website Development",
    description:
      "Professional responsive websites designed to build trust, communicate services, and generate customer enquiries.",
    examples: [
      "Business websites",
      "Startup websites",
      "Portfolio websites",
      "Service-company websites",
      "Landing pages",
      "Restaurant websites",
      "Organization websites",
    ],
  },
];

export const PROJECTS = [
  {
    id: "my-kitchen",
    title: "MY KITCHEN",
    category: "Food Ordering & Meal Subscription Platform",
    description:
      "A digital food-ordering solution designed around meals, subscriptions, ordering, delivery, and customer convenience.",
    highlights: [
      "Meal & subscription browsing",
      "Simple, guided ordering flow",
      "Delivery-ready order structure",
      "Customer-friendly interface",
    ],
    mockup: "myKitchen",
  },
  {
    id: "click-2-home",
    title: "Click 2 Home",
    category: "Home Service & Technician Platform",
    description:
      "A service platform designed to connect customers with technicians and simplify service requests, bookings, and job management.",
    highlights: [
      "Service category discovery",
      "Technician booking workflow",
      "Job & request management",
      "Clean customer experience",
    ],
    mockup: "click2Home",
  },
  {
    id: "labour-marketplace",
    title: "Labour Marketplace",
    category: "Skilled Worker Marketplace",
    description:
      "A digital marketplace designed to help customers discover and connect with skilled workers and service professionals.",
    highlights: [
      "Worker category browsing",
      "Skilled-worker profiles",
      "Service discovery workflow",
      "Straightforward connect flow",
    ],
    mockup: "labourMarketplace",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Tell Us Your Idea",
    description: "We understand your business, goals, users, and requirements.",
  },
  {
    step: "02",
    title: "Planning & Design",
    description: "We organize the project structure, screens, workflow, and user experience.",
  },
  {
    step: "03",
    title: "Development",
    description: "We build the application or website according to the agreed project scope.",
  },
  {
    step: "04",
    title: "Testing",
    description: "We test important functionality, responsiveness, usability, and workflows.",
  },
  {
    step: "05",
    title: "Launch",
    description: "We help prepare the completed product for deployment or release.",
  },
  {
    step: "06",
    title: "Support",
    description:
      "We provide assistance for updates, improvements, and technical requirements after launch.",
  },
];

export const WHY_US = [
  {
    icon: "Settings2",
    title: "Custom Solutions",
    description: "Every project is designed around the client's actual business requirement.",
  },
  {
    icon: "Cpu",
    title: "Modern Technology",
    description: "We focus on responsive, practical, scalable, and modern digital products.",
  },
  {
    icon: "MessageSquare",
    title: "Clear Communication",
    description:
      "Clients should understand what is being developed and how the project is progressing.",
  },
  {
    icon: "LifeBuoy",
    title: "Post-Launch Support",
    description:
      "We assist clients with reasonable technical support, updates, and future improvements after launch.",
  },
];

export const SERVICE_OPTIONS = ["Mobile Application", "Web Application", "Website"];
